import { getSelectedConditionOption } from './condition-filter-util.js';
import { getCorrectTimeLevel } from './date-time-filter-util.js';
import { ConditionFilterType, DatetimeLevel, DEFAULT_FILTER_JAQL_WRAPPER, FILTER_TYPES, FilterModalType, nonSupportedMinutesBuckets, } from './types.js';
const isIncludeAllFilter = (filter) => filter === null || filter === void 0 ? void 0 : filter.all;
const getInnerPeriodFilter = (filter) => (filter.last ? filter.last : filter.next);
const isPeriodFilter = (filter) => { var _a; return ((_a = getInnerPeriodFilter(filter)) === null || _a === void 0 ? void 0 : _a.offset) < 2; };
export const isSpecificItemsFilter = (filter) => { var _a; return ((_a = filter === null || filter === void 0 ? void 0 : filter.members) === null || _a === void 0 ? void 0 : _a.length) >= 0; };
const isFromOrToDefined = (fromRange, toRange) => (fromRange && typeof fromRange === 'string') || (toRange && typeof toRange === 'string');
const isFromAndToEmpty = (from, to) => from === '' && to === '';
const isDateRangeFilter = (filter, dataType) => {
    const { from, to } = filter;
    if (dataType !== FilterModalType.DATE_TIME)
        return false;
    if (isFromOrToDefined(from, to))
        return true;
    return isFromAndToEmpty(from, to);
};
export const isNumericRangeFilter = (filter) => {
    const { from, to } = filter;
    return !!(from !== undefined && to !== undefined && !filter.isBetween);
};
export const isConditionFilter = (filter) => getSelectedConditionOption(filter) !== ConditionFilterType.NONE;
const isAdvancedFilter = (filter) => Object.keys(filter).includes('isAdvanced');
const isTimeLevelNotSupported = (timeData) => !!(timeData.level &&
    timeData.bucket &&
    timeData.level === DatetimeLevel.MINUTES &&
    nonSupportedMinutesBuckets.includes(timeData.bucket));
const isInvalidFilter = (filter) => filter.filterType === FILTER_TYPES.INVALID;
export const getFilterType = (filter, dataType = FilterModalType.DATE_TIME, timeData) => {
    if (timeData && isTimeLevelNotSupported(timeData))
        return FILTER_TYPES.ADVANCED;
    if (isAdvancedFilter(filter))
        return FILTER_TYPES.ADVANCED;
    if (isIncludeAllFilter(filter))
        return FILTER_TYPES.INCLUDE_ALL;
    if (isPeriodFilter(filter))
        return FILTER_TYPES.PERIOD;
    if (isSpecificItemsFilter(filter))
        return FILTER_TYPES.SPECIFIC_ITEMS;
    if (isDateRangeFilter(filter, dataType))
        return FILTER_TYPES.DATE_RANGE;
    if (isNumericRangeFilter(filter))
        return FILTER_TYPES.NUMERIC_RANGE;
    if (isConditionFilter(filter))
        return FILTER_TYPES.CONDITION;
    if (isInvalidFilter(filter))
        return FILTER_TYPES.INVALID;
    return FILTER_TYPES.INVALID;
};
/**
 * Extracts Filter Type from Filter Jaql
 *
 * @param jaql - jaql
 * @param dataType - data type
 * @return FilterJaqlWrapperType
 * @internal
 */
export const extractFilterTypeFromFilterJaql = (jaql, dataType) => {
    const { level: filterLevel, filter, bucket } = jaql;
    const filterFromJaql = filter || DEFAULT_FILTER_JAQL_WRAPPER.filter;
    const filterToReturn = {
        filter: Object.assign(Object.assign({}, filterFromJaql), { filterType: getFilterType(filterFromJaql, dataType) }),
    };
    if (dataType === FilterModalType.DATE_TIME) {
        const backgroundFilter = filterFromJaql;
        const level = (backgroundFilter === null || backgroundFilter === void 0 ? void 0 : backgroundFilter.level) || filterLevel;
        filterToReturn.level = getCorrectTimeLevel(level, bucket);
        filterToReturn.filter.filterType = getFilterType(filterFromJaql, dataType, { level, bucket });
    }
    return filterToReturn;
};
//# sourceMappingURL=filter-types-util.js.map